const Vue = require("vue");
import HotelDestination from "./HotelDestination.vue";

Array.from(document.querySelectorAll(".js-hotel-destination-section")).forEach(item => {
  new Vue({
    el: item,
    components: {
      HotelDestination,
    },
    data() {
      return {
        isLoaded: true,
      }
    },
  })
})